import { urlForFolder } from '@verisart/shared/src/utils/resizeImage'

const imageLoader = ({ src, width }: { src: string; width: number }) =>
  `https://res.cloudinary.com/verisart/image/upload/ar_1.0,w_${width},c_fill/${urlForFolder(
    src
  )}`

export default imageLoader
